import { AnyObject } from 'types';
import { Node } from 'slate';

export type FindNode = (findFunction: FindFunction) => CustomNode | undefined;

type CustomNode = Node & AnyObject;

type FindFunction = (node: CustomNode) => boolean;

export default function findNode(editor): FindNode {
  return function (findFunction: FindFunction): CustomNode | undefined {
    return editor.children
      .flatMap((children) => children.children)
      .find(findFunction);
  };
}
